
import {minicart, homeUrl} from './bundle'
//from è la data di partenza del booking
function addToCart(productId, sizeId, qty, from = null) {
    return new Promise(resolve => {
        let formData = new FormData()
        formData.append('productId', productId)
        formData.append('sizeId', sizeId)
        formData.append('qty', qty)
        formData.append('from', from)
        formData.append('action', 'add_to_cart')
        let url = homeUrl + '/opzione-sito/ajax-cart'
        let request = new XMLHttpRequest()
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                updateIconBagCount(res.total_prods)
                minicart.minicart.setAttribute('data-total-item', res.total_prods)
                minicart.minicartEmpty.classList.add('hidden')
                minicart.minicartContainer.innerHTML = res.content
                minicart.minicartContainerTotal.innerHTML = res.total
                resolve()

            }
        }
        request.send(formData)
    })
}

function updateCart(productId, sizeId, itemKey, qty) {
    return new Promise(resolve => {
        let action = 'update_cart'
        let formData = new FormData()
        formData.append('productId', productId)
        formData.append('sizeId', sizeId)
        formData.append('itemKey', itemKey)
        formData.append('qty', qty)
        formData.append('action', action)
        let url = homeUrl + '/opzione-sito/ajax-cart'
        let request = new XMLHttpRequest()
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                updateIconBagCount(res.total_prods)      
                minicart.minicart.setAttribute('data-total-item', res.total_prods)          
                minicart.minicartContainerTotal.innerHTML = res.total
                resolve()
            }
        }
        request.send(formData)
    })
}

function removeFromCart(key, isCheckoutPage = false) {
    return new Promise(resolve => {
			let formData = new FormData()
			let request = new XMLHttpRequest()
			formData.append('action', 'remove_from_cart')
			formData.append('key', key)
			let url = document.getElementById('uri').value + '/AJAX/cart.php'
			request.open('POST', url, true)
			request.send(formData)
			request.onreadystatechange = () => {
				if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
					let res = JSON.parse(request.response)
					minicart.minicart.setAttribute('data-total-item', res.total_prods)     
					updateIconBagCount(res.total_prods)
					minicart.minicartContainerTotal.innerHTML = res.total
					if(isCheckoutPage){
						minicart.minicartContainer.innerHTML = res.content
						// console.log(res.content)
					}
					resolve(res)
				}
			}
    })
}

function updateIconBagCount(totalProducts) {
    let svgBagCount = document.querySelector('.svg-bag-count')
    let svgNotEmpty = document.querySelector('.svg-not-empty')
    if(totalProducts === 0){
        svgNotEmpty.classList.add('hide')
        svgBagCount.classList.remove('hide')
    }
    else{
        svgNotEmpty.classList.remove('hide')
        svgBagCount.classList.add('hide')        
    }
    // iconaBagQty.innerHTML = totalProducts
    // gsap.to(iconaBagQty, {
    //     duration: 0.4,
    //     autoAlpha: 1
    // })
}

export {addToCart, updateCart, removeFromCart}
